var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "5px",
    height: "5px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -38 -209 )"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 40.5 209  C 41.9 209  43 210.1  43 211.5  C 43 212.9  41.9 214  40.5 214  C 39.1 214  38 212.9  38 211.5  C 38 210.1  39.1 209  40.5 209  Z ",
    fillRule: "nonzero",
    fill: "#d9001b",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedDot);
export default __webpack_public_path__ + "static/media/red-dot.63db746f3cc9447d124e0e29ff9ed5a2.svg";
export { ForwardRef as ReactComponent };